module.exports = __webpack_public_path__ + "img/top_item.c9b02c8a.png";